import React, { createContext, useContext, useEffect, useState, useMemo } from 'react';
import { initializeFirebaseApp } from '../firebase';

const FirebaseContext = createContext(null);

/**
 * FirebaseProvider
 * Initializes Firebase app and Firestore, making them available to all child components
 */
export const FirebaseProvider = ({ children }) => {
    const [app, setApp] = useState(null);
    const [db, setDb] = useState(null);
    const [isInitialized, setIsInitialized] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const { app, db } = initializeFirebaseApp();
        setApp(app);
        setDb(db);
        setIsInitialized(true);
    }, []);

    const value = useMemo(() => ({
        app,
        db,
        isInitialized,
        error,
    }), [app, db, isInitialized, error]);

    return (
        <FirebaseContext.Provider value={value}>
            {children}
        </FirebaseContext.Provider>
    );
};

/**
 * Hook to access Firebase context
 * @returns {Object} { app, db, initializing, error }
 */
export const useFirebase = () => {
    const context = useContext(FirebaseContext);
    if (!context) {
        throw new Error('useFirebase must be used within a FirebaseProvider');
    }
    return context;
};
